import { Schema } from "@effect/schema";
import { Address } from "@silo/types";

export type RestrictionsBody = typeof RestrictionsBody.Type;
export type RestrictionsBodyEncoded = typeof RestrictionsBody.Encoded;

export const RestrictionsBody = Schema.Struct({
  address: Address,
}).annotations({ identifier: "RestrictionsBody" });

export type RestrictionsResponse = typeof RestrictionsResponse.Type;
export type RestrictionsResponseEncoded = typeof RestrictionsResponse.Encoded;

export const RestrictionsResponse = Schema.Struct({
  isBlocked: Schema.Boolean,
}).annotations({ identifier: "RestrictionsResponse" });
